import { create } from "zustand";
import { TBooking } from "~/types/booking";
import { TInventory } from "~/types/inventory";
import { TServiceTicket } from "~/types";
// Enhanced store with invoice configuration support

export enum BookingTab {
  OVERVIEW = "overview",
  SERVICES = "services",
  INVENTORY = "inventory",
  DOCUMENTS = "documents",
  COMMUNICATION = "communication",
  NOTES = "notes",
  BILLING = "billing",
}

type State = {
  booking?: TBooking;
  activeTab: BookingTab;
  selectedInventory?: TInventory;
  invoiceConfig?: InvoiceConfig;
  showServiceForm: boolean;
  showEstimateForm: boolean;
  showInventoryModal: boolean;
  isAddingNewService: boolean;
  editingEstimateService?: TServiceTicket | null;
};

type Actions = {
  setActiveTab: (tab: BookingTab) => void;
  setBooking: (booking: TBooking) => void;
  setSelectedInventory: (inventory?: TInventory) => void;
  setInvoiceConfig: (config: InvoiceConfig) => void;
  clearInvoiceConfig: () => void;
  setShowServiceForm: (show: boolean) => void;
  setShowEstimateForm: (show: boolean) => void;
  setShowInventoryModal: (show: boolean) => void;
  setIsAddingNewService: (isAdding: boolean) => void;
  setEditingEstimateService: (service: TServiceTicket | null) => void;
};

const initialState: State = {
  activeTab: BookingTab.OVERVIEW,
  showServiceForm: false,
  showEstimateForm: false,
  showInventoryModal: false,
  isAddingNewService: false,
  editingEstimateService: null,
};

export const useDetailBookingStore = create<State & Actions>()((set) => ({
  ...initialState,
  setActiveTab: (tab) => set(() => ({ activeTab: tab })),
  setBooking: (booking) => set(() => ({ booking })),
  setSelectedInventory: (selectedInventory) => set(() => ({ selectedInventory })),
  setInvoiceConfig: (invoiceConfig) => set(() => ({ invoiceConfig })),
  clearInvoiceConfig: () => set(() => ({ invoiceConfig: undefined })),
  setShowServiceForm: (showServiceForm) => set(() => ({ showServiceForm })),
  setShowEstimateForm: (showEstimateForm) => set(() => ({ showEstimateForm })),
  setShowInventoryModal: (showInventoryModal) => set(() => ({ showInventoryModal })),
  setIsAddingNewService: (isAddingNewService) => set(() => ({ isAddingNewService })),
  setEditingEstimateService: (editingEstimateService) => set(() => ({ editingEstimateService })),
}));
